import React from 'react';
import { TransactionTypeEnum } from '@/services/types/TransactionData';
import EmergePayTransactionIcon from './EmergePayTransactionIcon';
import { AdminTransactionIcon } from './AdminTransactionIcon';
import { TransactionIcon } from './TransactionIcon';
import { AvatarWithIconProps } from './AvatarWithIconPropsInterface';

const getIcon = (props: AvatarWithIconProps) => {
  switch (props.data.type) {
    case TransactionTypeEnum.Admin:
      return <AdminTransactionIcon {...props} />;
    case TransactionTypeEnum.EmergePay:
      return <EmergePayTransactionIcon {...props} />;
    default: {
      return <TransactionIcon {...props} />;
    }
  }
};

const AvatarWithIcon: React.FC<AvatarWithIconProps> = (props) => {
  return <div>{getIcon(props)}</div>;
};

export default AvatarWithIcon;
